import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Per-route SEO. Sets title, description, and optional JSON-LD.
 */
export default function Seo({ title, description, jsonLd, noindex = false }) {
    return (
        <Helmet>
            {title && <title>{title}</title>}
            {description && <meta name="description" content={description} />}
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    );
}
